export default "__VITE_ASSET__Dlt3QH9t__"